/**
 * Tur Bilgi Formu görsel görünürlüğü (14.10.2026, Ürün Sahibi: "olmayan fotolar var").
 *
 * Kırık ya da alakasız kare hiç gösterilmez; az kare yanlış kareden iyidir. `<img onError>` yüklenemeyen adresi buraya
 * yazar, kare formdan kalkar. Güvenli olmayan (http/https dışı, boş) adres baştan gösterilmez.
 */
export function adresGuvenli(adres: string): boolean {
  if (!adres.trim()) return false;
  try {
    return ['http:', 'https:'].includes(new URL(adres, 'https://x.invalid').protocol);
  } catch {
    return false;
  }
}

export function kirikEkle(kirik: ReadonlySet<string>, adres: string): ReadonlySet<string> {
  return kirik.has(adres) ? kirik : new Set([...kirik, adres]);
}

export function gorunurMu(adres: string, kirik: ReadonlySet<string>): boolean {
  return adresGuvenli(adres) && !kirik.has(adres);
}
